export const environment = {
  production: true,
  clientId: '261302296103747584',
  loginURL: 'https://discordapp.com/api/oauth2/authorize',
  apiURL: 'https://api.avrae.io',
  mediaURL: 'https://media.avrae.io',
  baseURL: 'https://avrae.dev'
};

// The beta environment is pretty much the same as the prod environment, except that it's hosted on avrae.dev
// instead of avrae.io.
